export const GOOGLE_AUTH = {
  clientId: process.env.NEXT_PUBLIC_GOOGLE_O_AUTH_CLIENT_ID || '',
  scope: process.env.NEXT_PUBLIC_GOOGLE_O_AUTH_SCOPE || '',
} as const;
